import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { WindMillLoading } from 'react-loadingg';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import Grid from '@material-ui/core/Grid';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';

import { getPathParameter, pascalCase } from '../utils';
import { getProductsByCategoryId } from '../actions/productAction';
import { getCategoryByPathName } from '../actions/categoryAction';
import masterBuilderLogo from '../assets/master-builders-logo.png';

import '../styles/products.scss';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Products = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const classes = useStyles();

  const { products, areProductsLoading, isLoaded } = useSelector(
    (state) => state.products
  );

  const { category, isCategoryLoading } = useSelector(
    (state) => state.categories
  );

  const [categoryId, setCategoryId] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [brochure, setBrochure] = useState('');
  const [isOldBrochure, setOldBrochure] = useState(false);
  const [productList, setProductList] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackBarStatus, setSnackBarStatus] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarAutoHideDuration, setSnackBarAutoHideDuration] = useState(
    3000
  );

  const pageMetaDescription = categoryName + ' Construction Chemical Product';

  useEffect(() => {
    const { state, pathname } = location;

    if (state && state.categoryId && !areProductsLoading) {
      setCategoryId(state && state.categoryId);
      setCategoryName(state && state.categoryName);
      setBrochure(state && state.brochure);
      setOldBrochure(state && state.isOldBrochure);
      dispatch(getProductsByCategoryId(state.categoryId));
    } else if (
      category &&
      Object.keys(category).length > 0 &&
      category.id &&
      !isCategoryLoading
    ) {
      dispatch(getProductsByCategoryId(category.id));
      setCategoryId(category.id);
      setCategoryName(category.name);
      setBrochure(category.brochure);
      setOldBrochure(category.isOldBrochure);
    } else {
      let categoryName = getPathParameter(pathname, 2);
      dispatch(getCategoryByPathName(decodeURI(categoryName)));
      setCategoryName(categoryName);
    }
  }, [dispatch, location, category, isCategoryLoading]);

  useEffect(() => {
    if (categoryId && products.length > 0 && isLoaded && !areProductsLoading) {
      setProductList(products);
      setDataLoaded(true);
    } else if (isLoaded && !areProductsLoading) {
      setProductList(products);
      setDataLoaded(true);
    }
  }, [products, areProductsLoading, isLoaded]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowSnackBar(false);
  };

  const handleOldBrochure = () => {
    setSnackBarStatus('success');
    setSnackBarAutoHideDuration(3000);
    setSnackBarMessage('Brochure Coming Soon');
    setShowSnackBar(true);
  };

  const renderProducts = () => {
    return productList.map((product, index) => (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        xl={2}
        key={index}
        className="product-grid-item"
      >
        <NavLink
          key={product.id}
          className="product-item"
          to={{
            pathname: `/products/${product.name}`,
            state: { product },
          }}
          exact={true}
        >
          <div className="image-container">
            <img src={masterBuilderLogo} alt={product.tagline} />
          </div>
          <div className="description-container">
            <h1 className="title">{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </NavLink>
      </Grid>
    ));
  };

  return (
    <div className="products-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pascalCase(categoryName)}</title>
        <meta name="description" content={pascalCase(pageMetaDescription)} />
        <meta name="keywords" content={pascalCase(categoryName)} />
        <meta property="og:title" content={pascalCase(categoryName)} />
        <meta
          property="og:description"
          content={pascalCase(pageMetaDescription)}
        />
        {/* <link
          rel="canonical"
          href={`http://revaintl.com/keyword/${categoryName}/`}
        /> */}
        <link rel="canonical" href="http://revaintl.com/" />
        <meta
          property="og:url"
          content={`http://revaintl.com/${categoryName}/`}
        />
        <meta property="og:site_name" content="Reva International" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/RevaInternationalME"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          content={pascalCase(pageMetaDescription)}
        />
        <meta name="twitter:title" content={pascalCase(categoryName)} />
      </Helmet>
      {products.length === 0 && dataLoaded ? (
        <span className="no-data-found">No Products Found</span>
      ) : null}

      <Snackbar
        open={showSnackBar}
        autoHideDuration={snackBarAutoHideDuration}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={snackBarStatus}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <div className="breadcrumb-container">
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumbs">
          <NavLink to="/home">
            <h1>{categoryName}</h1>
          </NavLink>

          <span color="textPrimary">Products</span>
        </Breadcrumbs>
        {/* <a
          href={brochure}
          target="_blank"
          rel="noopener noreferrer"
          className="brochure"
          download
        >
          Check Brochure
        </a> */}

        {isOldBrochure ? (
          <Button className="brochure" onClick={handleOldBrochure}>
            Check Brochure
          </Button>
        ) : (
          <a
            href={brochure}
            target="_blank"
            rel="noopener noreferrer"
            className="brochure"
            download
          >
            Check Brochure
          </a>
        )}
      </div>

      <Backdrop open={areProductsLoading} className={classes.backdrop}>
        <WindMillLoading color="#ef7f1b" />
      </Backdrop>

      <Grid container spacing={8} className="products-grid-container">
        {renderProducts()}
      </Grid>
    </div>
  );
};

export default Products;
